import React from 'react';
import GenericSection from '../components/sections/GenericSection';
import Accordion from '../components/elements/Accordion';
import AccordionItem from '../components/elements/AccordionItem';
import SectionHeader from '../components/sections/partials/SectionHeader';
import DocumentMeta from 'react-document-meta';
const genericSection04Header = {
  title: 'About Our Team'
}


class About extends React.Component {
  render() {
    const meta = {
      title: 'Autonomy Resources - About Us',
      description: 'Over a decade of combined experience building web and mobile applications and integrations'
    };
    return (
      <DocumentMeta {...meta}>
      <div>
      <GenericSection topDivider className="illustration-section-06">
        <div className="container-xs">
          <SectionHeader data={genericSection04Header} className="center-content" />
          <Accordion>
            <AccordionItem title="Our Founders" active>
              Matt Deatherage met Lalit Sethi while working on a contract together in 2019, and quickly found that they could build a team that
              was unrivaled when it came to rapid development of full stack applications and integrations. Since then, the team scales up and down
              with talented developers from all over the world, across a wide variety of specialities
            </AccordionItem>
            <AccordionItem title="What we Specialize in">
              We Build Web & Mobile Applications, APIs, and Middleware.
            </AccordionItem>
            <AccordionItem title="What Languages We Use">
              We specialize in Ruby and JavaScript development across many different frameworks
            </AccordionItem>
            <AccordionItem title="What Tools we Use">
              We have partnered with the leading tools for CRM, Document Automation, E-Commerce, and Payment Processing. Our team provides
              A-La-Carte ideas for our clients, and customizes the tools to fit exact use cases.
            </AccordionItem>
            <AccordionItem title="Companies We Work With">
              We typically work with companies between 10-300 employees, most of which have development teams that are too busy or too small
              to handle requests from other business units.
            </AccordionItem>
          </Accordion>
        </div>
      </GenericSection>
      </div>
      </DocumentMeta>
    );
  }
}

export default About;
